import React from 'react';
export const CFIconArrowCornerDownLeft = {
    alias: 'arrow-corner-down-left',
    defaultTitle: 'Arrow Corner Down Left',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M19.97 5.996a1 1 0 0 0-1-.996h-.003a1 1 0 0 0-.996 1.004l.02 5a.997.997 0 0 1-.995 1.004l-8.92.037 2.686-3.386a1 1 0 0 0-1.566-1.243l-3.98 5.016c-.29.367-.287.885.006 1.25l4.02 4.983a.998.998 0 0 0 1.406.15 1 1 0 0 0 .15-1.406l-2.713-3.364 8.918-.037a2.981 2.981 0 0 0 2.119-.887 2.984 2.984 0 0 0 .87-2.125l-.021-5Z' }))),
};
